import { defineMessages } from 'react-intl';

export const scope = 'app.containers.BulkActionQueue.components.ProgressIcon';

export default defineMessages({
  complete: {
    id: `${scope}.complete`,
    defaultMessage: 'Complete',
    description:
      'Accessible name of the status icon shown when a bulk job finished',
  },
  errored: {
    id: `${scope}.errored`,
    defaultMessage: 'Failed',
    description:
      'Accessible name of the status icon shown when a bulk job ended with an error',
  },
});
